import type { GetStaticProps } from 'next'
import { useTranslation } from 'next-i18next'
import AuthLayout from 'components/Layouts/auth'
import SignupForm from 'components/SignupForm'
import { serverSideTranslations } from "next-i18next/serverSideTranslations"

const SignUp = () => {
  const { t } = useTranslation('auth')

  return (
    <AuthLayout title={t('titles.signup')}>
      <SignupForm />
    </AuthLayout>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      locale,
      ...(await serverSideTranslations(locale!, ['common', 'auth']))
    }
  }
}

export default SignUp
